import styled from "@emotion/styled";
import { HorizontalCard } from "../ui/cards/horizontal";
import { StaticImage } from "gatsby-plugin-image";
import { SectionCommon } from "../layout/section-common";
import { Feature } from "../ui/cards/feature";
import { Vertical } from "../ui/cards/vertical";

const StyledBetterResults = styled.div`
  background-color: var(--off-white);
`;

export const BetterResults = () => (
  <StyledBetterResults>
    <SectionCommon
      title="Get Better Results for Your Clients With a Trusted White Label SEO Agency"
      headerStyles={{
        maxWidth: "900px",
        marginBottom: "var(--x-small)",
        textAlign: "center"
      }}
      styles={{ textAlign: "left" }}
    >
        <div className="cards">
          <HorizontalCard
            title="SEO & Marketing Expertise"
            text="Our 100% USA-based team of SEO experts use only the latest and proven strategies to achieve optimal results for your clients' SEO campaigns. Our innovative approach and expansive experience in helping agencies scale will give you an upper hand in delivering SEO results for your clients."
          >
            <StaticImage
              src="../../images/seo/marketing-expertise.png"
              alt="SEO and Marketing Expertise"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Results-Driven Strategy"
            text="Many white label SEO agencies focus only on long-tail or easy to rank keywords to show positive campaign performance while ignoring metrics that actually drive businesses forward. Our strategy and approach are based on ranking for competitive keywords, driving real traffic that converts, and generating actual phone calls to move the ROI needle for your clients."
          >
            <StaticImage
              src="../../images/seo/results-driven-startegy.png"
              alt="SEO and Marketing Expertise"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Increase Organic Search Engine Rankings in Google"
            text="Google’s organic search engine rankings appear below the first set of paid ads and directly below the Maps listings for many searches. Our white label SEO ensures your clients rank on page one of Google’s organic search results pages, in conjunction with improving Maps rankings as well."
          >
            <StaticImage
              src="../../images/seo/organic.png"
              alt="SEO and Marketing Expertise"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>
        </div>

        <Feature
          title="Increase Google Maps & Google Business Profile (GBP) Rankings in Google"
          text="For local SEO, it's imperative your clients rank in the Maps section, which appears above organic rankings and below the few top ads spots, as Maps and GBP rankings are critical for any local business trying to rank for local searches. Our strategy includes an aggressive and proven approach to move the needle for your clients' local SEO campaigns."
        >
          <StaticImage
            src="../../images/seo/client-ranking-high.png"
            alt="Google Maps"
          />
        </Feature>

        <div className="vertical-cards">
          <Vertical
            title="Increase Website Traffic"
            text="Website traffic increases come from targeting keywords that drive actual search volume. One of the core strategies integrated in all of our campaigns is targeting short-tail and competitive keywords that have a lot of monthly search volume, as they’re what will drive the most impactful results for your clients."
          >
            <StaticImage
              src="../../images/seo/increase-website-traffic.png"
              alt="Increase Website Traffic"
              class="img-container"
            />
          </Vertical>

          <Vertical
            title="Increase Brand Visibility"
            text="By implementing a cross-channel campaign that focuses on organic, Maps/GBP, and competitive keywords, you'll see an increase in brand visibility and uptake in market share. This is critical for any business seeking to improve their digital presence on Google or online in general."
          >
            <StaticImage
              src="../../images/seo/increase-brand-visibility.png"
              alt="Increase Brand Visibility"
              class="img-container"
            />
          </Vertical>
        </div>

        <Feature
          title="Increase Click-through Rates (CTR)"
          text="Clickthrough-rate (CTR) is an important metric used by Google and assessing it with bounce rate to determine how many visitors are coming back after clicking on a certain result typically indicates if that website is providing the proper result or answer for that searcher. We can naturally improve click-through rates by writing custom title tags and matching them to the correct keywords after performing proper keyword research, as by aligning content and optimizations, we can boost CTR rates."
          inverted={true}
        >
          <StaticImage
            src="../../images/seo/increase-ctr.png"
            alt="Increase Click-through Rates (CTR)"
          />
        </Feature>

        <div className="cards">
          <HorizontalCard
            title="Increase Conversions"
            text="Often overlooked aspects of SEO campaigns are tracking conversions and properly attributing them to the SEO campaign. This can be achieved through several methods including Google Tag Manager and tracking scripts that capture form submissions and phone calls while separating from paid and other marketing channels."
          >
            <StaticImage
              src="../../images/seo/increase-conversions.png"
              alt="Increase Conversions"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Reduce Bounce Rate"
            text="Reducing bounce rate is very important as website speeds decrease when more interactive content is added, and more visitors than ever leave websites before they even load. This results in massive waste and lots of lost opportunity. By improving website speed and performance, we can lower bounce rate and improve conversion rates."
          >
            <StaticImage
              src="../../images/seo/reduce-bounce-rate.png"
              alt="Reduce Bounce Rate"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Increase Online Sales"
            text="SEO campaigns are more than keyword rankings and website traffic from Google. If a campaign isn’t increasing online sales or leads, then it's not effective. We recommend tracking all aspects of an SEO campaign to assess ROI and the impact to online and offline sales."
          >
            <StaticImage
              src="../../images/seo/increase-online-sales.png"
              alt="Increase Online Sales"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>

          <HorizontalCard
            title="Happier Clients"
            text="The most important metric of any white label SEO campaign are happy clients who see positive value, ROI, and results. Developing happy clients is the key to success in reducing churn rates and improving lifetime value (LTV) of your clients, and we’ll help you improve lifetime value and reduce churn with our results-driven and proven white label SEO solutions."
          >
            <StaticImage
              src="../../images/seo/happier-clients.png"
              alt="Happier Clients"
              imgClassName="img"
              class="img-container"
              placeholder="none"
            />
          </HorizontalCard>          
        </div>
    </SectionCommon>
  </StyledBetterResults>
);
